<template>
  <section id="program" ref="program">
    <div class="big spacer">
      <div class="title">{{ program.title }}</div>
      <div class="pt pb bb" v-html="program.friday"></div>
      <div class="pt" v-html="program.saturday"></div>
    </div>

    <div
      class="spacer"
      v-if="program.eventsfriday && program.eventsfriday.length > 0"
    >
      <div class="big title">{{ $t("friday") }}</div>
      <collapse
        v-for="item in program.eventsfriday"
        :key="'fri-' + item.title"
        :uid="item.uid"
        parent="program"
        :fold="true"
      >
        <template v-slot:header>
          <div class="first">{{ item.hour }}h, {{ item.stage }}</div>
          <span v-for="speaker in item.speaker" :key="speaker.name">
            {{ speaker.name }}, {{ speaker.occupation }}<br />
          </span>
        </template>
        <template v-slot:left>
          {{ item.title }}
        </template>
        <template v-slot:content>
          <div
            class="grid mb"
            v-for="speaker in item.speaker"
            :key="speaker.name"
          >
            <div>
              <img
                v-if="speaker.image"
                :src="speaker.image.url"
                :alt="speaker.name"
              />
            </div>
            <div v-html="speaker.bio"></div>
          </div>
          <div v-html="item.description"></div>
        </template>
      </collapse>
    </div>

    <div
      class="spacer"
      v-if="program.eventssaturday && program.eventssaturday.length > 0"
    >
      <div class="big title">{{ $t("saturday") }}</div>
      <collapse
        v-for="item in program.eventssaturday"
        :key="'sat-' + item.title"
        :uid="item.uid"
        :fold="true"
      >
        <template v-slot:header>
          <div class="first">{{ item.hour }}h, {{ item.stage }}</div>
          <span v-for="speaker in item.speaker" :key="speaker.name">
            {{ speaker.name }}, {{ speaker.occupation }}<br />
          </span>
        </template>
        <template v-slot:left>
          {{ item.title }}
        </template>
        <template v-slot:content>
          <div
            class="grid mb"
            v-for="speaker in item.speaker"
            :key="speaker.name"
          >
            <div>
              <img
                v-if="speaker.image"
                :src="speaker.image.url"
                :alt="speaker.name"
              />
            </div>
            <div v-html="speaker.bio"></div>
          </div>
          <div v-html="item.description"></div>
        </template>
      </collapse>
    </div>
  </section>
</template>

<script>
import API from "@/api/service";
import Collapse from "@/components/Collapse.vue";
export default {
  components: {
    Collapse
  },
  data() {
    return {
      program: [],
      loaded: false
    };
  },
  watch: {
    $route() {
      API.program(this.$i18n.locale).then(page => {
        this.program = page.data.result;
      });
    }
  },
  created() {
    API.program(this.$i18n.locale).then(page => {
      this.program = page.data.result;
      this.loaded = true;
    });
  },
  mounted() {
    if (this.$route.params.pathMatch == "program") {
      if (this.loaded) {
        this.$scrollTo("#" + this.$route.params.pathMatch, 1000);
      }
    }
  }
};
</script>

<style></style>
